import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import JsBarcode from 'jsbarcode';

@Directive({
    selector: 'svg[barcode]',
})
export class BarcodeDirective implements OnChanges {
    @Input() barcode!: string;
    @Input() barcodeFormat: string = 'CODE128';
    @Input() barcodeWidth: number = 1.5;
    @Input() barcodeHeight: number = 40;
    @Input() barcodeDisplayValue: boolean = true;
    @Input() barcodeFontSize: number = 10;

    constructor(private el: ElementRef<SVGElement>) {}

    ngOnChanges(): void {
        if (!this.barcode) return;
        JsBarcode(this.el.nativeElement, this.barcode, {
            format: this.barcodeFormat,
            width: this.barcodeWidth,
            height: this.barcodeHeight,
            displayValue: this.barcodeDisplayValue,
            fontSize: this.barcodeFontSize,
            margin: 4,
        });
    }
}
